import { buttonSchema } from '@ecomm/shared-components'
import { gatsbyHeroBannerSchema } from '@ecomm/shared-components/lib/HeroBanner/schema'
import { affirmBannerApolloSchema } from '@ecomm/shared-data'
import {
  featureSectionSchema,
  gastbyColoredSectionSchema,
  gatsbyDuplexSectionSchema,
  gatsbyReviewSectionSchema,
  twoColumnTextSchema
} from '@ecomm/shared-sections'
import { type TypeOf, z } from '@simplisafe/ewok'

import { trustPilotSchema } from '../../trustPilot'
import { layoutReferenceSchema } from '../LayoutReference/schema'
import { smallTextSchema } from '../SmallText/schema'

// this is temporary while we migrate to Apollo
const gatsbyGrid = z.object({
  contentful_id: z.string(),
  __typename: z.literal('ContentfulGrid')
})

export const componentSchema = z.union([
  gatsbyReviewSectionSchema,
  gatsbyGrid,
  gatsbyDuplexSectionSchema,
  gastbyColoredSectionSchema,
  featureSectionSchema,
  buttonSchema,
  trustPilotSchema,
  affirmBannerApolloSchema,
  z.object({
    __typename: z.literal('ContentfulAnchorSection'),
    contentful_id: z.string(),
    name: z.string()
  }),
  gatsbyHeroBannerSchema,
  layoutReferenceSchema,
  twoColumnTextSchema,
  smallTextSchema
])

export const contentCollectionSchema = z.object({
  content: componentSchema.array(),
  __typename: z.literal('ContentfulContentCollection')
})

export type ComponentTypes = TypeOf<typeof componentSchema>
export type ContentCollectionProps = TypeOf<typeof contentCollectionSchema>
